import ColumnExcel from '@/services/excel/generator/columnExcel';
import ExportExcel from '@/services/excel/generator/exportExcel';
import SheetExcel from '@/services/excel/generator/sheetExcel';
import { ExportToExcel } from '@/services/excel/generator/excelGenerator';

export const columnsCommande = [
  new ColumnExcel('Numéro interne de la commande', 'code', true),
  new ColumnExcel('Date de signature', 'dateDevisCommande', true),
  new ColumnExcel('Role commande', 'role', true),
  new ColumnExcel('Commercial(e)', 'commercial'),
  new ColumnExcel('Assistant(e)', 'assistant'),
  new ColumnExcel('Agence', 'agence', true),
  new ColumnExcel('Référence client', 'referenceClient'),
  new ColumnExcel('Code dossier', 'codeDossier'),
  new ColumnExcel('Thème', 'theme'),
  new ColumnExcel('Renouvelable', 'renouvelable'),
  new ColumnExcel('Reconductible tacitement', 'reconductible'),
  new ColumnExcel('Date de renouvellement', 'dateRenouvellement'),
  new ColumnExcel('Date de préavis', 'datePreavis'),
  new ColumnExcel('Commentaire Interne', 'commentaireInterne'),
  new ColumnExcel('Commentaire commande', 'commentaire'),
  new ColumnExcel('Adresse de livraison', 'adresseLivraison'),
  new ColumnExcel('Date de début d\'échéancier', 'echeancierDateDebut'),
  new ColumnExcel('Date de fin d\'échéancier', 'echeancierDateFin'),
  new ColumnExcel('Date de fin de première échéance', 'echeancierDateFinPremiereEcheance'),
  new ColumnExcel('Total ht', 'montantHt', true),
  new ColumnExcel('Total tva', 'montantTva', true),
  new ColumnExcel('Total ttc', 'montantTtc', true),
];

export const columnsIntervenantCommande = [
  new ColumnExcel('Numéro interne de la commande', 'codeCommande', true),
  new ColumnExcel('Code Tiers', 'codeTiers'),
  new ColumnExcel('Référence externe Tiers', 'referenceExterne'),
  new ColumnExcel('Nom du tiers', 'nomCommercial'),
  new ColumnExcel('Quote Part', 'repartition'),
  new ColumnExcel('Payeur', 'payeur'),
  new ColumnExcel('Annonceur', 'annonceur'),
  new ColumnExcel('Mandataire', 'mandataire'),
  new ColumnExcel('Donneur ordre', 'donneurOrdre'),
  new ColumnExcel('Nouveau client', 'nvClient'),
];

function getColumnsLigneNormal(key, libelle) {
  return [
    new ColumnExcel(`Référence produit ${libelle}`, `referenceProduit${key}`),
    new ColumnExcel(`Founisseur ${libelle}`, `fournisseur${key}`),
    new ColumnExcel(`Qté ${libelle}`, `quantite${key}`),
    new ColumnExcel(`Unite ${libelle}`, `unite${key}`),
    new ColumnExcel(`PU ${libelle}`, `prixUnitaire${key}`),
    new ColumnExcel(`Montant brut ${libelle}`, `montantBrut${key}`),
    new ColumnExcel(`Taux de remise ${libelle} (%)`, `tauxDeRemise${key}`),
    new ColumnExcel(`Montant net ${libelle}`, `montantNet${key}`),
    new ColumnExcel(`Taux de TVA ${libelle}`, `tauxTva${key}`),
    new ColumnExcel(`Montant première échéance ${libelle}`, `montantPremiereEcheance${key}`),
  ];
}

export const columnsLigneCommande = [
  new ColumnExcel('Numéro interne de la commande', 'codeCommande', true),
  new ColumnExcel('Référence produit', 'produit'),
  new ColumnExcel('Libellé produit', 'libelleProduit'),
  new ColumnExcel('Date début', 'dateDebut', true),
  new ColumnExcel('Date fin', 'dateFin', true),
  new ColumnExcel('Confrere', 'confrere'),
  new ColumnExcel('Code panneau', 'codePanneau'),
  new ColumnExcel('Format', 'format'),
  new ColumnExcel('Type de matériel', 'typeDeMateriel'),
  new ColumnExcel('Support', 'support'),
  new ColumnExcel('Localisation', 'localisation'),
  new ColumnExcel('Angle de vision', 'angleDeVision'),
  new ColumnExcel('Azimut', 'azimut'),
  new ColumnExcel('Eclaire', 'eclaire'),
  new ColumnExcel('Proposable en Réseau', 'proposableReseau'),
  new ColumnExcel('Disposition', 'disposition'),
  new ColumnExcel('En venant de', 'enVenantDe'),
  new ColumnExcel('En allant vers', 'enAllantVers'),
  new ColumnExcel('Motif de non commercialisation', 'faceMotifNonCom'),
  new ColumnExcel('Restriction d\'affichage', 'restrictionsAffichage'),
  new ColumnExcel('Adresse', 'adresse', false, 300),
  new ColumnExcel('Code postal', 'codePostal'),
  new ColumnExcel('Ville', 'ville'),
  new ColumnExcel('Département', 'departement'),
  new ColumnExcel('Agglomération', 'agglomeration'),
  new ColumnExcel('Latitude', 'latitude'),
  new ColumnExcel('Longitude', 'longitude'),
  ...getColumnsLigneNormal('Location', 'location'),
  ...getColumnsLigneNormal('Tlpe', 'TLPE'),
  ...getColumnsLigneNormal('FraisTechnique', 'frais technique'),
  ...getColumnsLigneNormal('FraisPose', 'frais pose'),
  ...getColumnsLigneNormal('Honoraire', 'honoraire'),
];

export function templateConfig(data) {
  return new ExportExcel(
    'TemplateCommande.xlsx',
    [
      new SheetExcel(
        'Commande',
        columnsCommande,
        data[0],
        { skipHeader: false },
      ),
      new SheetExcel(
        'Intervenant',
        columnsIntervenantCommande,
        data[1],
        { skipHeader: false },
      ),
      new SheetExcel(
        'Ligne de commande',
        columnsLigneCommande,
        data[2],
        { skipHeader: false },
      ),
    ],
  );
}

export default function generatedTemplateCommandeGenerale() {
  const commande = {
    code: 'C9425020002',
    dateDevisCommande: '04/02/2025',
    commercial: 'averrier',
    assistant: 'advjoy',
    agence: 'Nimes',
    referenceClient: '',
    codeDossier: '',
    theme: '',
    renouvelable: 'OUI',
    reconductible: 'OUI',
    dateRenouvellement: '03/02/2026',
    datePreavis: '03/11/2025',
    commentaireInterne: '',
    commentaire: '',
    adresseLivraison: '',
    role: '',
    echeancierDateDebut: '04/02/2025',
    echeancierDateFin: '03/02/2026',
    echeancierDateFinPremiereEcheance: '05/08/2025',
    echeancierMontant: 200,
    montantHt: 850,
    totalTva: 160,
    montantTtc: 1010,
  };

  const ligneCommande = {
    devisCommande: 'C9425020002',
    produit: '00062A01A',
    libelleProduit: '00062A01A / L100 X H215 / 11, Rue John Hadley 59650 Villeneuve-d\'Ascq',
    supportCommercial: 'Unitaire',
    dateDebut: '04/02/2025',
    dateFin: '03/02/2026',
    confrere: '',
    codePanneau: '00062A',
    format: 'L100 X H215',
    typeDeMateriel: 'Fixe',
    support: '',
    localisation: '',
    angleDeVision: '',
    azimut: '',
    eclaire: '',
    proposableLc: 'OUI',
    proposableReseau: 'OUI',
    disposition: '',
    enVenantDe: '',
    enAllantVers: '',
    faceMotifNonCom: '',
    restrictionsAffichage: '',
    adresse: 'Quadra Diffusion',
    codePostal: '59650',
    ville: 'Villeneuve-d\'Ascq',
    departement: 'Nord',
    agglomeration: '',
    latitude: '50.60950700000001',
    longitude: '3.1513046',
    referenceLocation: 'LCUnite',
    quantiteLocation: 1,
    uniteLocation: 'Unite',
    prixUnitaireLocation: 800,
    montantBrutLocation: 800,
    tauxDeRemiseLocation: 0,
    montantNetLocation: 800,
    referenceProduitTlpe: 'TlpeLc',
    quantiteTlpe: 1,
    uniteTlpe: 'Unite',
    prixUnitaireTlpe: 20,
    montantBrutTlpe: 20,
    tauxDeRemiseTlpe: 0,
    montantNetTlpe: 20,
    referenceProduitFraisTechnique: 'PITAY FI FSTD 6',
    fournisseurFraisTechnique: '',
    quantiteFraisTechnique: 1,
    uniteFraisTechnique: 'jour',
    prixUnitaireFraisTechnique: 500,
    montantBrutFraisTechnique: 500,
    tauxDeRemiseFraisTechnique: 0,
    montantNetFraisTechnique: 500,
    referenceProduitFraisPose: 'HC FI ADHESIF PLUS DE 20M2',
    fournisseurFraisPose: '',
    quantiteFraisPose: 1,
    uniteFraisPose: 'Unite',
    prixUnitaireFraisPose: 22.5,
    montantBrutFraisPose: 22.5,
    tauxDeRemiseFraisPose: 0,
    montantNetFraisPose: 22.5,
    referenceProduitHonoraire: 'honoraire',
    fournisseurHonoraire: '',
    quantiteHonoraire: 10,
    uniteHonoraire: 'Jour',
    prixUnitaireHonoraire: 200,
    montantBrutHonoraire: 200,
    tauxDeRemiseHonoraire: 0,
    montantNetHonoraire: 200,
  };

  const intervenants = {
    codeCommande: 'C9425020002',
    codeTiers: '3570',
    referenceExterne: '',
    nomCommercial: 'Fode PV',
    repartition: '100%',
    payeur: 'OUI',
    annonceur: 'OUI',
    mandataire: 'NON',
    donneurOrdre: 'OUI',
    nvClient: 'NON',
  };

  const config = templateConfig([[commande], [intervenants], [ligneCommande]]);
  ExportToExcel(config);
}
